(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sintonai-account"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript ? document.currentScript.closest('.snt-account') : null;
    var scope = root || document;
    var tabs = scope.querySelectorAll('[data-snt-tab]');
    var panels = scope.querySelectorAll('[data-snt-panel]');
    function activate(name) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-snt-tab') === name); });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-snt-panel') === name;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-snt-tab')); });
    });
    function applyHash() {
      var hash = (location.hash || '').replace('#', '');
      if (hash === 'pedidos' || hash === 'direcciones' || hash === 'favoritos' || hash === 'devoluciones' || hash === 'detalles') activate(hash);
    }
    applyHash();
    window.addEventListener('hashchange', applyHash);

    /* ── Favoritos + Devoluciones (storefront-account-api) ── */
    var host = document.querySelector('.snt-account');
    var CID = host ? host.getAttribute('data-customer-id') : '';
    var SHOP = host ? host.getAttribute('data-shop') : '';
    var CEMAIL = host ? host.getAttribute('data-customer-email') : '';
    var CNAME = host ? host.getAttribute('data-customer-name') : '';
    var API = 'https://dyjrkolyblnolngsbtez.supabase.co/functions/v1/storefront-account-api';
    var KEY = host ? host.getAttribute('data-api-key') : '';
    function api(opts) {
      return fetch(API + (opts.qs || ''), {
        method: opts.method || 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + KEY, 'apikey': KEY },
        body: opts.body ? JSON.stringify(opts.body) : undefined,
      }).then(function (r) { return r.json(); });
    }
    function loadWishlist() {
      var box = document.getElementById('snt-wishlist');
      if (!box || !CID) return;
      api({ qs: '?shop=' + SHOP + '&customer_id=' + CID }).then(function (d) {
        var items = d.wishlist || [];
        if (!items.length) { box.innerHTML = '<p class="snt-account__empty">Tu lista de favoritos está vacía.</p>'; return; }
        box.innerHTML = items.map(function (i) {
          return '<div class="snt-account__wish-item">' +
            '<a href="/products/' + i.product_handle + '">' + (i.product_image ? '<img src="' + i.product_image + '" alt="">' : '') + '</a>' +
            '<p><a href="/products/' + i.product_handle + '" style="color:currentColor;text-decoration:none">' + (i.product_title || i.product_handle) + '</a></p>' +
            (i.product_price ? '<p class="price">' + i.product_price + '</p>' : '') +
            '<button class="snt-account__wish-remove" data-handle="' + i.product_handle + '">Quitar</button>' +
          '</div>';
        }).join('');
        box.querySelectorAll('.snt-account__wish-remove').forEach(function (b) {
          b.addEventListener('click', function () {
            api({ method: 'POST', body: { action: 'wishlist_toggle', shop: SHOP, customer_id: CID, product: { handle: b.getAttribute('data-handle') } } })
              .then(loadWishlist);
          });
        });
      });
    }
    // Fusiona favoritos guardados como invitado antes de pintar la lista
    if (window.BRWishlist && CID) { BRWishlist.merge().then(loadWishlist); } else { loadWishlist(); }

    // Badge de Le Club: solo para socias, con sus puntos reales
    var badge = document.getElementById('snt-club-badge');
    if (badge && CID) {
      fetch('https://dyjrkolyblnolngsbtez.supabase.co/functions/v1/loyalty-widget-api?shop=' + SHOP + '&customer_id=' + CID,
        { headers: { 'Authorization': 'Bearer ' + KEY, 'apikey': KEY } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.member) {
            badge.textContent = 'Le Club · ' + (d.member.blues_balance || 0) + ' Les Blues · ' + (d.member.rouges_balance || 0) + ' Les Rouges';
            badge.hidden = false;
          }
        }).catch(function () {});
    }

    // Códigos del club canjeados por la socia.
    //
    // Se leen del mismo GET que ya alimenta el badge de Le Club. Los pendientes
    // van arriba con botón de copiar; los gastados quedan debajo, tachados, para
    // que se vea que ese canje se consumió y que puede sacar otro.
    function loadCodes() {
      var box = document.getElementById('snt-codes');
      if (!box) return;
      if (!CID) { box.innerHTML = '<p class="snt-account__empty">Inicia sesión para ver tus códigos.</p>'; return; }

      api({ qs: '?shop=' + SHOP + '&customer_id=' + CID }).then(function (d) {
        var items = ((d && d.redemptions) || []).filter(function (r) { return r.discount_code; });
        if (!items.length) {
          box.innerHTML = '<p class="snt-account__empty">Todavía no has canjeado ninguna recompensa.</p>';
          return;
        }
        var activos = items.filter(function (r) { return r.status !== 'used'; });
        var usados  = items.filter(function (r) { return r.status === 'used'; });
        var esc = function (t) { return String(t == null ? '' : t).replace(/</g, '&lt;'); };
        var fecha = function (d2) { try { return new Date(d2).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }); } catch (e) { return ''; } };

        var fila = function (r, gastado) {
          return '<div class="snt-code' + (gastado ? ' is-used' : '') + '">'
            + '<div><span class="snt-code-label">' + esc(r.label) + '</span>'
            + '<span class="snt-code-date">' + fecha(r.created_at) + (gastado ? ' · usado' : '') + '</span></div>'
            + '<div class="snt-code-right"><code class="snt-code-value">' + esc(r.discount_code) + '</code>'
            + (gastado ? '' : '<button type="button" class="snt-code-copy" data-code="' + esc(r.discount_code) + '">Copiar</button>')
            + '</div></div>';
        };

        box.innerHTML =
          (activos.length ? activos.map(function (r) { return fila(r, false); }).join('')
                          : '<p class="snt-account__empty">No tienes códigos pendientes de usar.</p>')
          + (usados.length ? '<div class="snt-codes-used-t">Ya utilizados</div>'
                             + usados.map(function (r) { return fila(r, true); }).join('') : '');

        box.querySelectorAll('.snt-code-copy').forEach(function (b) {
          b.addEventListener('click', function () {
            navigator.clipboard && navigator.clipboard.writeText(b.getAttribute('data-code'));
            var antes = b.textContent;
            b.textContent = '¡Copiado!';
            setTimeout(function () { b.textContent = antes; }, 1800);
          });
        });
      }).catch(function () {
        box.innerHTML = '<p class="snt-account__empty">No pudimos cargar tus códigos.</p>';
      });
    }
    loadCodes();

    // Portal de seguimiento de devoluciones: lista las solicitudes y su estado.
    function loadReturns() {
      var box = document.getElementById('snt-returns-list');
      if (!box || !CID || !CEMAIL) return;
      api({ qs: '?shop=' + SHOP + '&customer_id=' + CID + '&returns=1&email=' + encodeURIComponent(CEMAIL) }).then(function (d) {
        var items = (d && d.returns) || [];
        if (!items.length) { box.hidden = true; return; }
        var STATUS = { open: ['En revisión', 'is-open'], resolved: ['Resuelta', 'is-resolved'] };
        box.innerHTML = '<h3 class="snt-account__returns-title">Tus solicitudes</h3>' + items.map(function (r) {
          var s = STATUS[r.status] || STATUS.open;
          var date = r.created_at ? new Date(r.created_at).toLocaleDateString('es-ES') : '';
          return '<div class="snt-return-row">'
            + '<div><span class="snt-return-order">' + (r.order || 'Pedido') + '</span>'
            + (r.reason ? '<span class="snt-return-reason">' + r.reason.replace(/</g, '&lt;').slice(0, 80) + '</span>' : '')
            + '<span class="snt-return-date">' + date + '</span></div>'
            + '<span class="snt-return-status ' + s[1] + '">' + s[0] + '</span></div>';
        }).join('');
        box.hidden = false;
      });
    }
    loadReturns();

    var rf = document.getElementById('snt-return-form');
    if (rf) rf.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = document.getElementById('snt-return-msg');
      var btn = rf.querySelector('button[type="submit"]');
      btn.disabled = true;
      api({ method: 'POST', body: {
        action: 'return_request', shop: SHOP, customer_id: CID, email: CEMAIL, name: CNAME,
        order_name: document.getElementById('snt-return-order').value,
        reason: document.getElementById('snt-return-reason').value,
      } }).then(function (d) {
        msg.hidden = false;
        msg.textContent = d.ok ? 'Solicitud enviada. Te contactaremos en breve ✦' : (d.error || 'No se pudo enviar, inténtalo de nuevo.');
        if (d.ok) {
          rf.querySelectorAll('select,textarea,button').forEach(function (el) { el.disabled = true; });
          setTimeout(loadReturns, 800);
        } else btn.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
